import { ButtonVariant, ErrorPage } from './ErrorPage';

type ForbiddenPageProps = {
    errorText?: string,
}

export const ForbiddenPage = ({ errorText }: ForbiddenPageProps) => {

    return (
        <ErrorPage
            code={403}
            errorText={errorText ?? 'У вас нет доступа к этой странице'}
            buttonVariant={ButtonVariant.Hide}
        />
    );
}